/* eslint-disable max-len */
import React from "react";
import { useNavigate } from "react-router-dom";

const LedgerTable = ({
    mainHeading, 
    ledgerData,  
    totalBalance,
    totalBalanceType,
    searchParams,
    setSearchParams,
    setSubLedgerWithGroupseLoading,
    setTransactionTableLoading,
    mainPath, 
    setPageType}) => {

    const navigate = useNavigate()

    /**
     * The function `subLegderHandler` determines the page type based on item properties and updates search
     * parameters before navigating to a specific URL in a financial statements application.
     * @returns In the provided `subLegderHandler` function, the return statements are currently set to
     * return nothing. The function will exit without returning any value when the conditions `id ===
     * 'ledger'` or `id === 'group'` are met.
     */
    const subLegderHandler = (id, hasChild, item,  dataName, itemName, isTransaction, ledgerID) => {
        if((!hasChild && !isTransaction)){
            return
        } else {
            let params = Object?.fromEntries(searchParams);
            ledgerID ? params.ledger_id = ledgerID: ''
            if(id=== 'ledger'){
            // Determine page type based on item properties
                if (isTransaction){
                    setPageType('transaction');
                    params.type = 'transaction'
                    setTransactionTableLoading(true)
                } else {
                    setPageType('group');
                    setSubLedgerWithGroupseLoading(true)
                    params.type = 'group'
                }
                
                // Update type parameter in params based on item properties
                setSearchParams({...params});
                let theLedgerName = ''
                if(isTransaction){
                    theLedgerName = itemName+' Ledger Extract'
                }else{
                    theLedgerName = itemName
                }
                params.drill_down_type = mainHeading.toLowerCase()
                // Update searchParams and navigate to the appropriate URL
                navigate(`/financial-statements/receipts-and-payments/${mainPath}/${
                    encodeURIComponent(dataName)}/${
                    encodeURIComponent(theLedgerName)}${
                    Object.keys(params).length === 0 ? '' : `?${new URLSearchParams(params).toString()}`}`);  
            }
            if(id === 'group'){
                setPageType('mainGroup')
                params.type = 'mainGroup';
                params.drill_down_type = mainHeading.toLowerCase()
                // Update type parameter in params based on item properties
                setSearchParams({...params});
                // Update searchParams and navigate to the appropriate URL
                navigate(`/financial-statements/receipts-and-payments/${mainPath}/${
                    encodeURIComponent(dataName)}${
                    Object.keys(params).length === 0 ? '' : `?${new URLSearchParams(params).toString()}`}`);  
            }
        }
    }

    /**
     * The function `displayBalance` formats and displays a balance amount based on its type and value.
     * @returns The function `displayBalance` returns the formatted balance based on the type of
     * transaction. If the type is "cr" (credit) and the balance is negative, it returns the absolute value
     * of the balance with a negative sign in front. Otherwise, it returns the balance formatted with two
     * decimal places.
     */
    const displayBalance = (type, balance) => {
        if (type === "cr" && balance !== 0) {
            return `(-)${Math.abs(parseFloat(balance)).toFixed(2)}`;
        }
        return parseFloat(balance).toFixed(2);
    };

    return (
        <div className="relative min-h-full">
            <h2 id={`${mainHeading}_mainHeading`}className="px-[10px] h-[36px] flex justify-between items-center text-lg font-semibold text-[#106EB4] bg-[#EEF7FE]">{mainHeading}</h2>
            <div className="pb-10">
                {ledgerData?.map((data, index) => (
                    <div key={index+data} className="py-[8px]">
                        <div className="flex justify-between px-[12px] font-semibold">
                            <p className={`${(data?.has_child || data?.is_transaction) ? 'cursor-pointer' :''} break-all hover:text-[#106EB4]`}
                                onClick={() => subLegderHandler('group', data?.has_child, data, data?.name)}
                                id={mainHeading+'_'+data?.name}>
                                {data?.name}
                            </p>
                            <p className={`amount ${(data?.has_child || data?.is_transaction) ? 'cursor-pointer' :''} min-w-[120px] pl-2 text-end hover:text-[#106EB4]`}
                                onClick={() => subLegderHandler('group', data?.has_child, data, data?.name)}
                                id={mainHeading+'_'+data?.name+'_amount'}>
                                {displayBalance(data?.type, data?.balance)}
                            </p>
                        </div>
                        <ul className="pl-[32px] pr-[110px] font-normal  py-[3px]">
                            {data?.items?.map((item, subIndex) => (
                                <li className="flex justify-between py-[3px]" key={subIndex+item}>
                                    {/* add cursor-point */}
                                    <p className={`${(item?.has_child || item?.is_transaction) || (item?.name === 'P & L Account') ? 'cursor-pointer' :''} ${item?.name_type === 'group' ? '' : 'text-[#333]'} break-all hover:text-[#106EB4]`}
                                        onClick={() => subLegderHandler('ledger', item?.has_child, item, data?.name, item?.name, item?.is_transaction, item?.ledger_id)}
                                        style={{ fontWeight: item?.name_type === 'group' ? '400' : 'normal' }}
                                        id={mainHeading+'_'+item?.name}>
                                        {item?.name}
                                    </p>
                                    <p className={`amount ${(item?.has_child || item?.is_transaction)  || (item?.name === 'P & L Account') ? 'cursor-pointer' :''} ${item?.name_type === 'group' ? '' : 'text-[#333]'} pl-2 hover:text-[#106EB4]`}
                                        onClick={() => subLegderHandler('ledger', item?.has_child, item, data?.name, item?.name, item?.is_transaction, item?.ledger_id)}
                                        style={{ fontWeight: item?.name_type === 'group' ? '400' : 'normal' }}
                                        id={mainHeading+'_'+item?.name+'_amount'}>
                                        {displayBalance(item?.type, item?.balance)}
                                    </p>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            <div className="absolute bottom-0 text-base left-0 w-full px-[10px] h-[36px] font-semibold bg-[#EEF7FE] flex justify-between items-center">
                <p>Total</p>
                <p id={mainHeading+'_total_amount'}>{displayBalance(totalBalanceType, totalBalance)}</p>
            </div>
        </div>
    )
}

export default LedgerTable;